module.exports = __webpack_public_path__ + "img/hero-visual-right-v2.07d6b0af.png";